import { render } from "./Basic_Information.vue?vue&type=template&id=66e69fcf&scoped=true"
import script from "./Basic_Information.vue?vue&type=script&lang=js"
export * from "./Basic_Information.vue?vue&type=script&lang=js"

import "./Basic_Information.vue?vue&type=style&index=0&id=66e69fcf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66e69fcf"]])

export default __exports__